require('aws-sdk/lib/node_loader');
module.exports = {
  WheatleyMessagePreviewer: require('./wheatleymessagepreviewer')
};